import { CheckValidateProject, GetTxReceipt, ValidateProject } from "src/models";
import { Credentials } from "src/models/instantiateClass";
import { ImportExternalProject } from "src/models/utilities/importExternalProject";
import { axiosRequest } from "./axiosCore";

export const getTxReceipt = async (payload: GetTxReceipt, initialize: Credentials) => {
    return await axiosRequest('/utilities/txReceipt', payload, initialize);
 }
 
 export const validateProject = async (payload: ValidateProject, initialize: Credentials) => {
    return await axiosRequest('/validateProject', payload, initialize);
 }

 export const checkValidateProject = async (payload: CheckValidateProject, initialize: Credentials) => {
   return await axiosRequest('/checkProjectValidation', payload, initialize);
}

export const importExternalProject = async (payload: ImportExternalProject, initialize: Credentials) => {
   return await axiosRequest('/importExternalProject', payload, initialize);
}